






import Vue from 'vue';

export default Vue.extend({
  name: 'VerticalNavigation',
  props: {
    label: {
      type: String,
      default: 'Navigation',
    },
  },
});
